import { Box, Tooltip, Typography, useTheme } from '@mui/material';
import { Check } from '@mui/icons-material';
import { useEffect, useRef } from 'react';
import { Draggable } from '@fullcalendar/interaction';

interface CalendarStageProps {
  type?: 'default' | 'success' | 'error' | 'warning';
  title?: string;
  icon?: JSX.Element;
  completed?: boolean;
  count?: number;
  id?: any;
}

export const CalendarStage = ({
  type = 'default',
  icon,
  title = 'No title',
  completed = false,
  count,
  id,
}: CalendarStageProps) => {
  const theme = useTheme();
  // TODO: theme doesn't work here????
  // need to figure out
  theme.palette.primary.main = '#163B3F';
  theme.palette.secondary.main = '#76B041';
  const eventColor =
    type === 'default' || completed
      ? theme.palette.primary.main
      : type === 'success'
      ? theme.palette.secondary.main
      : type === 'error'
      ? theme.palette.error.main
      : type === 'warning'
      ? theme.palette.warning.main
      : theme.palette.primary.main;

  const eventBgColor = `${eventColor}20`;

  const eventRef = useRef();
  useEffect(() => {
    if (eventRef.current) {
      new Draggable(eventRef.current);
    }
  }, [eventRef]);

  return (
    <Box
      ref={eventRef}
      sx={{
        bgcolor: eventBgColor,
        color: eventColor,
        borderRadius: 0.25,
        overflow: 'hidden',
        paddingX: 1,
        paddingY: 0.5,
        border: `5px solid ${eventColor}`,
        cursor: 'pointer',
        transition: `all 100ms ease`,
        display: 'flex',
        alignItems: 'center',

        // '&:hover': {
        //   borderLeftWidth: 10,
        //   // px: 2,
        // },
      }}
      data-id={id}
    >
      {completed && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: `${theme.palette.text.primary}`,
            color: theme.palette.primary.contrastText,
            width: 12,
            height: 12,
            borderRadius: 0.25,
            marginRight: 0.5,
          }}
        >
          <Check
            sx={{
              color: 'inherit',
              fontSize: 12,
            }}
          />
        </Box>
      )}
      {icon && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            // bgcolor: `${theme.palette.text.primary}`,
            // color: theme.palette.primary.contrastText,
            width: 12,
            height: 12,
            borderRadius: 0.25,
            marginRight: 0.5,
          }}
        >
          {icon}
        </Box>
      )}
      <Typography
        sx={{
          fontSize: 12,
          lineHeight: 1,
          letterSpacing: 0.4,
          fontWeight: 600,
        }}
      >
        {`${title} stage due`}
      </Typography>

      {count !== undefined && (
        <Typography
          sx={{
            fontSize: 10,
            lineHeight: 1,
            letterSpacing: 0.4,
            marginLeft: 0.5,
            color: theme.palette.text.primary,
            fontWeight: 500,
          }}
        >
          {count}
        </Typography>
      )}
    </Box>
  );
};
